// extracted by mini-css-extract-plugin
export var content = "_n5-1";
export var divider = "_n5-0";